<template>
  <div class="message">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'消息中心'}]"></breadcrumb>
    <div class="message-wrap">
      <div class="message-contain">
        <page-title title="消息列表"></page-title>
        <div class="message-table-wrap">
          <div class="message-table">
            <table>
              <tr @click="gotoReadMsg(item.id)" v-for="item in messageList" :key="item.id">
                <td class="message-table_col1" :class="{hasread:item.readStatus}">
                  <div
                    class="message-table_top"
                    :class="{hasread:item.readStatus}"
                    v-if="item.top"
                  >置顶</div>
                  <div
                    class="message-table_urgent"
                    :class="{hasread:item.readStatus}"
                    v-if="item.urgent"
                  >加急</div>
                  {{item.name}}
                </td>
                <td class="message-table_col2">
                  <div class="message-table_attachment" v-if="item.attachment">
                    <font-awesome-icon
                      style="margin-right:5px;"
                      :style="{color:!item.readStatus?'#F0722B':'#9B9B9B'}"
                      :icon="['fas', 'download']"
                    />
                    {{item.attachment.split(",").length + "个附件"}}
                  </div>
                  {{(item.updateTime||item.createTime)|timeFilter}}
                </td>
                <td
                  class="message-table_col3"
                  :style="{color:!item.readStatus?'#39b54a':'#9B9B9B'}"
                >{{!item.readStatus?'未读':'已读'}}</td>
              </tr>
            </table>
          </div>
          <el-pagination
            @current-change="changePage"
            :current-page="page"
            class="message-pagination"
            background
            layout="prev, pager, next"
            :total="listSize"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/servies/axios";
import api from "@/servies/api";
import breadcrumb from "@/components/breadcrumb";
import pageTitle from "@/components/pageTitle";
export default {
  components: {
    breadcrumb,
    pageTitle
  },
  filters: {
    timeFilter(value) {
      return value.replace("T", " ");
    }
  },
  data() {
    return {
      page: 1,
      messageList: [],
      listSize: 0
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //获取消息列表
    getList() {
      axios
        .get(api.listPage + `\\${this.page}\\10`)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取消息列表成功", res.data.result);
            this.messageList = res.data.result.records;
            this.listSize = res.data.result.total;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    },
    changePage(v) {
      this.page = v;
      this.getList();
    },
    gotoReadMsg(id){
      this.$router.push({ path: `/message/readmessage/${id}` });
    }
  }
};
</script>

<style lang="scss" scoped>
.message {
  .message-wrap {
    padding: 77px 30px 0px 30px;
    .message-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .message-table-wrap {
        padding: 30px;
        .message-table {
          min-height: 470px;
          tr {
            cursor: pointer;
            height: 47px;
            td {
              div {
                display: inline-block;
              }
            }
            .message-table_col1 {
              padding-left: 20px;
              font-weight: 600;
              &.hasread {
              color: #9b9b9b;
              font-weight: 400;
            }
              .message-table_urgent {
                font-size: 11px;
                color: #fff;
                background: #39b54a;
                width: 28px;
                height: 16px;
                border-radius: 2px;
                text-align: center;
                line-height: 16px;
                &.hasread {
                  background: #9b9b9b;
                }
              }
              .message-table_top {
                margin-right: 11px;
                font-size: 8px;
                color: #fff;
                background: #f0722b;
                width: 28px;
                height: 16px;
                border-radius: 2px;
                text-align: center;
                line-height: 16px;
                &.hasread {
                  background: #9b9b9b;
                }
              }
              div {
                &:last-child {
                  margin-right: 10px;
                }
              }
            }
            .message-table_col2 {
              width: 240px;
              text-align: right;
              padding-right: 67px;
              color: #9b9b9b;
              .message-table_attachment {
                text-align: left;
                width: 77px;
                color: #4a4a4a;
                margin-right: 25px;
              }
            }
            .message-table_col3 {
              width: 30px;
              padding-right: 47px;
            }
          }
        }
        .message-pagination {
          margin-top: 36px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
}
</style>
